import { render, staticRenderFns } from "./ContactUsView.vue?vue&type=template&id=5722478b"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"
import style0 from "./ContactUsView.vue?vue&type=style&index=0&id=5722478b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports